<template>
    <OrderList />
</template>

<script>
import OrderList from "../components/Home/OrderList";

export default {
    name: "Home",

    components: {
        OrderList,
    },
};
</script>
